/**
 * @module alerts
 */

/**
 * The Vuex 'state' object.
 * @name State
 * @type {object}
 * @property {boolean} synced アラートの読み込みが完了しているかどうか。
 * @property {object[]} groups カテゴリグループの配列。
 * @property {object[]} alerts 値引アラートの配列。
 */
const state = {
    synced: false,
    groups: [],
    alerts: [],
}

const getters = {
}

/**
 * The module 'mutations' object.
 * @name Mutators
 * @type {object}
 * @mutator {object} ignoreAlert=boolProp Sets the state boolean property.
 * @mutator {object} markAsDone=strProp Sets the state string property.
 * @mutator {object[]} applyGroups=numProp Sets the state numerical property.
 * @mutator {object[]} applyAlerts=numProp Sets the state numerical property.
 */
const mutations = {
/**
 * The module 'mutations' object.
 * @name Mutators
 * @type {object}
 * @mutator {object} ignoreAlert=boolProp Sets the state boolean property.
 * @mutator {object} markAsDone=strProp Sets the state string property.
 * @mutator {object[]} applyGroups=numProp Sets the state numerical property.
 * @mutator {object[]} applyAlerts=numProp Sets the state numerical property.
 */
 ignoreAlert(state, payload) {
        const alert = state.alerts.filter(a => a.item_cd == payload.item_cd)[0]
        alert.state = "ignored"
    },

    markAsDone(state, payload) {
        state.alerts.filter(a => a.item_cd == payload.item_cd)
            .forEach(alert => {
                alert.state = "done"
            });
    },

    applyGroups(state, payload) {
        state.groups = payload
    },

    applyAlerts(state, payload) {
        state.alerts = payload
        state.synced = true
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
